import { ProvisioningService } from "../services/provisioning.service";

// Hardcoded key
export async function importKeyHardcoded(): Promise<CryptoKey> {
  console.log("🔑 Using HARDCODED key");
  const byteArray = [
    0x5e, 0x2e, 0x10, 0x5d, 0x4f, 0x36, 0x4f, 0xbf, 0x00, 0x45, 0xfd, 0x3b,
    0x0c, 0x5b, 0x45, 0x8a,
  ];
  const key = await crypto.subtle.importKey(
    "raw",
    new Uint8Array(byteArray),
    { name: "AES-CBC" },
    false,
    ["encrypt", "decrypt"],
  );
  //console.log('✅ Hardcoded key imported');
  return key;
}

// Secret Manager key
/*
export async function importKeyFromSecret(prov: ProvisioningService): Promise<CryptoKey> {
  console.log('🔑 Using SECRET MANAGER key');
  const aesKey = await prov.getAesKeyFromS();
  console.log('✅ Secret Manager key imported');
  return aesKey;
}*/

// Main function - switches based on flag
/*
export async function importKey(prov: ProvisioningService): Promise<CryptoKey> {
  const USE_HARDCODED = false; // Toggle this for testing

  if (USE_HARDCODED) {
    return importKeyHardcoded();
  } else {
    return importKeyFromSecret(prov);
  }
}*/
/*
export async function compareKeys(prov: ProvisioningService): Promise<void> {
  console.log('🔍 === KEY COMPARISON TEST ===');

  // Get hardcoded key
  const hardcodedKey = await importKeyHardcoded();

  // Get secret manager key
  const secretKey = await importKeyFromSecret(prov);

  // Test data
  const testPlaintext = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]);
  const testIV = new Uint8Array(16); // Zero IV

  // Encrypt with hardcoded key
  const ct1Buf = await crypto.subtle.encrypt({ name: 'AES-CBC', iv: testIV }, hardcodedKey, testPlaintext);
  const ct1 = new Uint8Array(ct1Buf);

  // Encrypt with secret manager key
  const ct2Buf = await crypto.subtle.encrypt({ name: 'AES-CBC', iv: testIV }, secretKey, testPlaintext);
  const ct2 = new Uint8Array(ct2Buf);

  // Compare
  const match = ct1.length === ct2.length && ct1.every((b, i) => b === ct2[i]);

  console.log('🔍 Comparison Results:');
  console.log(
    '  Hardcoded CT:',
    Array.from(ct1.slice(0, 16))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join(' ')
  );
  console.log(
    '  Secret CT:   ',
    Array.from(ct2.slice(0, 16))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join(' ')
  );
  console.log('  Keys Match:', match ? '✅ YES' : '❌ NO');

  if (!match) {
    console.error('❌ KEYS ARE DIFFERENT!');
    throw new Error('Hardcoded and Secret Manager keys produce different results');
  }

  console.log('✅ Keys are identical');
  console.log('🔍 === END KEY COMPARISON ===');
}
*/
export async function importKey(prov: ProvisioningService): Promise<CryptoKey> {
  const HARDCODED = false; // Set to true to test

  if (HARDCODED) {
    // console.log('🔑 Using HARDCODED key');
    const byteArray = [
      0x5e, 0x2e, 0x10, 0x5d, 0x4f, 0x36, 0x4f, 0xbf, 0x00, 0x45, 0xfd, 0x3b,
      0x0c, 0x5b, 0x45, 0x8a,
    ];
    const key = await crypto.subtle.importKey(
      "raw",
      new Uint8Array(byteArray),
      { name: "AES-CBC" },
      false,
      ["encrypt", "decrypt"],
    );
    // console.log('✅ Hardcoded key imported');
    return key;
  }

  // console.log('🔑 Using SECRET MANAGER key');

  const aesKey = await prov.getAesKeyFromS();
  const s = await prov.unwrapS(); // Uint8Array(16/32)
  const h = await crypto.subtle.digest("SHA-256", new Uint8Array(s));
  //console.log('S#', Array.from(new Uint8Array(h)).slice(0, 4)); // tiny fingerprint
  // console.log(' Secret Manager key imported');

  return aesKey;
}

function u16be(n: number): Uint8Array {
  return new Uint8Array([(n >>> 8) & 0xff, n & 0xff]);
}

export async function decryptFrameWithIV(
  key: CryptoKey,
  frame: Uint8Array,
  messageIV: Uint8Array,
): Promise<Uint8Array> {
  // Validation and logging
  /* console.log('🔓 Decryption attempt:', {
    ivLength: messageIV.length,
    ivHex: Array.from(messageIV)
      .map((b) => b.toString(16).padStart(2, '0'))
      .join(''),
    frameLength: frame.length,
    frameIsMultipleOf16: frame.length % 16 === 0,
    keyAlgorithm: key.algorithm.name,
  });*/

  if (messageIV.length !== 16) {
    throw new Error(`IV must be 16 bytes, got ${messageIV.length}`);
  }

  if (frame.length === 0 || frame.length % 16 !== 0) {
    throw new Error(
      `Frame must be non-empty and multiple of 16 bytes, got ${frame.length}`,
    );
  }

  try {
    const iv = new Uint8Array(messageIV);
    const ptBuf = await crypto.subtle.decrypt(
      { name: "AES-CBC", iv },
      key,
      new Uint8Array(frame), // ✅ Pass Uint8Array directly, not .buffer
    );

    // console.log('✅ Decryption successful, plaintext length:', ptBuf.byteLength);
    return new Uint8Array(ptBuf);
  } catch (error) {
    console.error("❌ Decryption failed:", error);
    throw error;
  }
}
/*
export async function encryptFrameWithIV(
  key: CryptoKey,
  plaintext: Uint8Array,
  rawIV: Uint8Array
): Promise<Uint8Array> {
  // Convert rawIV to Uint8Array (should be 16 bytes for AES-CBC)
  const iv = new Uint8Array(rawIV); // ✅ Simpler conversion

  console.log(iv.length);

  if (iv.length !== 16) {
    throw new Error(`AES-CBC requires 16-byte IV, got ${iv.length}`);
  }

  // Verify key algorithm
  if (key.algorithm.name !== 'AES-CBC') {
    throw new Error(`Expected AES-CBC key, got ${key.algorithm.name}`);
  }

  // Encrypt with this IV
  const ctBuf = await crypto.subtle.encrypt(
    { name: 'AES-CBC', iv }, // ✅ Pass Uint8Array directly, not .buffer
    key,
    new Uint8Array(plaintext).buffer // ✅ Pass Uint8Array directly, not .buffer
  );
  const ct = new Uint8Array(ctBuf);

  if (ct.length % 16 !== 0) {
    throw new Error('CBC ct size must be multiple of 16');
  }

  // Generate random IV for embedding (if needed)
  // const randomIv = generateRandomIV();

  const out = new Uint8Array(16 + ct.length);
  out.set(u16be(16 + ct.length), 0); // Positions 0-1: length
  out.set(iv, 2); // Positions 2-17: IV ✅
  out.set(ct, 18); // Position 18+: CT ✅

  console.log('🔐 Encrypted with IV:', {
    ivHex: Array.from(iv)
      .map((b) => b.toString(16).padStart(2, '0'))
      .join(''),
    ctLen: ct.length,
  });

  return out;
}*/
export async function encryptFrameWithIV(
  key: CryptoKey,
  plaintext: Uint8Array,
  rawIV: Uint8Array,
): Promise<Uint8Array> {
  const iv = new Uint8Array(rawIV);

  if (iv.length !== 16) {
    throw new Error(`AES-CBC requires 16-byte IV, got ${iv.length}`);
  }

  const ctBuf = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    key,
    new Uint8Array(plaintext),
  );
  const ct = new Uint8Array(ctBuf);

  // Return IV + CT (no length header)
  const out = new Uint8Array(16 + ct.length);
  out.set(iv, 0); // IV first
  out.set(ct, 16); // CT after

  return out;
}

export async function encryptRawCbcZero(
  key: CryptoKey,
  pt: Uint8Array,
  rawIV: Uint8Array,
): Promise<Uint8Array> {
  const iv = new Uint8Array(rawIV);
  // console.log('this._aesKey', key, 'iv', iv);
  const ctBuf = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv: iv },
    key,
    new Uint8Array(pt).buffer,
  );
  const ct = new Uint8Array(ctBuf);
  if (ct.length === 0 || ct.length % 16 !== 0) {
    throw new Error(`CBC ciphertext must be multiple of 16 (got ${ct.length})`);
  }

  return ct; // <-- RAW CT only, just like device sends
}

export async function decryptRawCbcZero(
  key: CryptoKey,
  ct: Uint8Array,
  rawIV: Uint8Array,
): Promise<Uint8Array> {
  const iv = new Uint8Array(rawIV);
  // console.log('this._aesKey', key);
  if (ct.length === 0 || ct.length % 16 !== 0) {
    throw new Error(
      `CBC ciphertext must be a multiple of 16 (got ${ct.length})`,
    );
  }
  const ptBuf = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv: iv },
    key,
    new Uint8Array(ct).buffer,
  );

  return new Uint8Array(ptBuf); // Web Crypto removes PKCS#7 automatically
}
